import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en.json';
import es from './locales/es.json';
import zh from './locales/zh.json';

export type Locale = 'en' | 'es' | 'zh';

export const SUPPORTED_LOCALES: Array<{ code: Locale; label: string; native: string }> = [
  { code: 'en', label: 'English', native: 'English' },
  { code: 'es', label: 'Spanish', native: 'Español' },
  { code: 'zh', label: 'Chinese', native: '中文' },
];

// Single `translation` namespace keeps lookups simple. Keys are grouped by
// dotted path (e.g., nav.workOrders) so grep-ability stays good.
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
      zh: { translation: zh },
    },
    fallbackLng: 'en',
    supportedLngs: ['en', 'es', 'zh'],
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'tc-locale',
      caches: ['localStorage'],
    },
    interpolation: {
      // React already escapes
      escapeValue: false,
    },
  });

export function setLocale(locale: Locale) {
  void i18n.changeLanguage(locale);
}

export function currentLocale(): Locale {
  return (i18n.resolvedLanguage as Locale) ?? 'en';
}

export default i18n;
